import { getEncodedQuery } from '@app/logic/filters';
import { isEmpty } from '@app/utils/isEmpty';
import { ProductFilters } from '@typings';
import { useNavigate } from 'react-router-dom';

const FILTERS_QUERY_PARAM_NAME = 'filters';

export const useUrlProductFilters = () => {
  const navigate = useNavigate();

  return (filters: ProductFilters) => {
    const newValue = getEncodedQuery(filters);
    const params = new URLSearchParams(window.location.search);

    if (isEmpty(newValue)) {
      params.delete(FILTERS_QUERY_PARAM_NAME);
    } else {
      params.set(FILTERS_QUERY_PARAM_NAME, newValue);
    }

    const queryString = Array.from(params.entries())
      .map(([key, value]) =>
        key === FILTERS_QUERY_PARAM_NAME ? `${key}=${newValue}` : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
      )
      .join('&');

    navigate(`${location.pathname}?${queryString}`, { replace: true });
  };
};
